/* eslint camelcase:0 max-statements: 0 */

export default (values, props) => {
  const errors = {}
  const Stripe = window.Stripe
  const { mode } = props
  const { name, number, exp_month, exp_year, address_zip, cvc } = values
  const CREATE = mode === 'create'

  if (!name) {
    errors.name = 'name.required'
  }

  if (!address_zip) { // eslint-disable-line camelcase
    errors.address_zip = 'address_zip.required'
  }

  if (CREATE && !number) {
    errors.number = 'number.invalid'
  }

  if (CREATE && Stripe && !props.editing && !Stripe.card.validateCardNumber(number)) {
    errors.number = 'number.invalid'
  }

  if (Stripe && exp_month && exp_year && !Stripe.card.validateExpiry(exp_month, exp_year)) {
    errors.exp = 'exp.invalid'
  }

  if (!exp_month) {
    errors.exp_month = 'exp_month.invalid'
  }

  if (!exp_year) {
    errors.exp_year = 'exp_year.invalid'
  }

  if (!exp_year && !exp_month) {
    errors.exp = 'exp.invalid'
  }

  if (CREATE && !cvc) {
    errors.cvc = 'cvc.invalid'
  }

  if (CREATE && Stripe && !props.editing && !Stripe.card.validateCVC(cvc)) {
    errors.cvc = 'cvc.invalid'
  }

  return errors
}



// WEBPACK FOOTER //
// ./src/components/premium/CCForm/validate.js